/**
 * Vintage Set Detection
 * Cards from these sets use vintage pricing methods (top3, low3, etc.)
 * Everything else uses modern pricing (time-range averages).
 * Cutoff: sets released before 2017 (Sun & Moon era).
 */

const VINTAGE_SETS = [
  // Base era
  'base set', 'jungle', 'fossil', 'base set 2',
  // Team Rocket / Gym
  'team rocket', 'gym heroes', 'gym challenge',
  // Neo era
  'neo genesis', 'neo discovery', 'neo revelation', 'neo destiny',
  // Legendary / e-Series
  'legendary collection', 'expedition', 'aquapolis', 'skyridge',
  // Ruby & Sapphire era
  'ruby & sapphire', 'sandstorm', 'dragon', 'team magma vs team aqua',
  'hidden legends', 'firered & leafgreen', 'team rocket returns',
  'deoxys', 'emerald', 'unseen forces', 'delta species',
  'legend maker', 'holon phantoms', 'crystal guardians',
  'dragon frontiers', 'power keepers',
  // Diamond & Pearl era
  'diamond & pearl', 'mysterious treasures', 'secret wonders',
  'great encounters', 'majestic dawn', 'legends awakened',
  'stormfront', 'platinum', 'rising rivals', 'supreme victors',
  'arceus',
  // HeartGold SoulSilver era
  'heartgold & soulsilver', 'unleashed', 'undaunted',
  'triumphant', 'call of legends',
  // Black & White era
  'black & white', 'emerging powers', 'noble victories', 'next destinies',
  'dark explorers', 'dragons exalted', 'dragon vault', 'boundaries crossed',
  'plasma storm', 'plasma freeze', 'plasma blast', 'legendary treasures',
  // XY era
  'xy', 'flashfire', 'furious fists', 'phantom forces',
  'primal clash', 'double crisis', 'roaring skies', 'ancient origins',
  'breakthrough', 'breakpoint', 'generations', 'fates collide',
  'steam siege', 'evolutions',
  // Promos & specials (pre-2017)
  'southern islands', 'pop series',
  'wizards black star promos', 'nintendo black star promos',
];

/**
 * Check if a set name is vintage (pre-2017).
 * Uses fuzzy matching: lowercased includes check.
 */
export function isVintageSet(setName) {
  if (!setName) return false;
  const lower = setName.toLowerCase().trim();
  return VINTAGE_SETS.some(v => lower.includes(v) || v.includes(lower));
}

export { VINTAGE_SETS };
